import type React from "react";
import type { Field } from "@/entities/form-metadata";
import { MissingField } from "./MissingField";

interface WithPlaceholderProps {
    fieldData: Field<any> | undefined;
    fieldPath: string;
    inputProperties?: React.InputHTMLAttributes<HTMLInputElement>;
    assertion: string;
}

export function withPlaceholder<P extends WithPlaceholderProps>(Component: React.ComponentType<P>) {
    return function WithPlaceholder(props: P) {
        const { fieldData } = props;

        if (!fieldData) {
            return <MissingField />;
        }

        return <Component {...props} />;
    };
}
